export const PORTAL_EVENTS_PERMISSION_KEY = 'PortalEventos';
export const PORTAL_EVENTS_ALLOWED_KEY = 'PortalEventosPermitidos';

export function parsePermissions(rawPermissions) {
  if (!rawPermissions) return {};

  if (typeof rawPermissions === 'string') {
    try {
      return JSON.parse(rawPermissions) || {};
    } catch (error) {
      return {};
    }
  }

  return rawPermissions;
}

export function getModulePermissions(rawPermissions) {
  const permissions = parsePermissions(rawPermissions);

  return Object.fromEntries(
    Object.entries(permissions).filter(([, value]) => typeof value === 'boolean')
  );
}

export function getAllowedPortalEventIds(rawPermissions) {
  const permissions = parsePermissions(rawPermissions);
  const allowedEventIds = permissions?.[PORTAL_EVENTS_ALLOWED_KEY];

  if (!Array.isArray(allowedEventIds)) return [];

  return allowedEventIds
    .map((eventId) => Number(eventId))
    .filter((eventId) => Number.isInteger(eventId) && eventId > 0);
}
